import { render, staticRenderFns } from "./CardSubscribe.vue?vue&type=template&id=2717bba9"
import script from "./CardSubscribe.vue?vue&type=script&lang=js"
export * from "./CardSubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Markdown: require('/srv/app/components/markdown/Markdown.vue').default,Input: require('/srv/app/components/input/Input.vue').default,Button: require('/srv/app/components/button/Button.vue').default})
